import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import LightButton from '../button/LightButton';

const EditableSection = ({
  label,
  showSummary,
  summaryContent,
  children,
  withCancel = true,
  showSave = false,
  saveDisabled = false,
  onSave,
  onCancel,
}) => {
  const [editMode, setEditMode] = useState(false);

  const handleSave = () => {
    onSave?.();
    setEditMode(false);
  };

  const handleCancel = () => {
    onCancel?.();
    setEditMode(false);
  };

  return (
    <Card className="p-3 mb-3">
      {/* SUMMARY VIEW */}
      {showSummary && !editMode && (
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <div className="fw-bold">{label}</div>
            <div className="text-muted mt-1">{summaryContent}</div>
          </div>
          <LightButton onClick={() => setEditMode(true)}>Zmień</LightButton>
        </div>
      )}

      {/* EDIT MODE OR EMPTY STATE */}
      {(!showSummary || editMode) && (
        <>
          {withCancel ? (
            <div className="d-flex justify-content-between align-items-start gap-3">
              <div>
                <div>{children}</div>
              </div>
              <div className="d-flex gap-2">
                {showSave && (
                  <LightButton disabled={saveDisabled} onClick={handleSave}>
                    Zapisz
                  </LightButton>
                )}
                <LightButton onClick={handleCancel}>Anuluj</LightButton>
              </div>
            </div>
          ) : (
            <div>
              {children}
              {showSave && (
                <div className="d-flex justify-content-end mt-3">
                  <LightButton disabled={saveDisabled} onClick={handleSave}>
                    Zapisz
                  </LightButton>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </Card>
  );
};

export default EditableSection;
